import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSitemap = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <rect
      width={5}
      height={3.5}
      x={5.5}
      y={1.5}
      stroke={_.color}
      strokeWidth={1.2}
      rx={1}
    />
    <rect
      width={5}
      height={3.5}
      x={1.5}
      y={11}
      stroke={_.color}
      strokeWidth={1.2}
      rx={1}
    />
    <rect
      width={5}
      height={3.5}
      x={9.5}
      y={11}
      stroke={_.color}
      strokeWidth={1.2}
      rx={1}
    />
    <path
      stroke={_.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 5v2.75M4 11V7.75h8V11"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSitemap);
export default ForwardRef;
